export default __webpack_public_path__ + "static/noissuetv-background-bottom-223211992f1a2e629dfcd1929b7f7ca4.svg";